// extracted by mini-css-extract-plugin
export var lower = "RULLogo-module--lower--7acdc";
export var rul_svg__balls = "RULLogo-module--rul_svg__balls--4336c";